import { createReducer, on } from '@ngrx/store';
import { CompaniesUIActions } from '../actions';
import { CompaniesUIState } from '../company.types';

const initialState: CompaniesUIState = {
    filter: null,
    currentCompanyId: null,
    currentCompanyIdChanged: false,
    currentPeriod: null,
    currentPeriodChanged: false
};

export const reducer = createReducer(
    initialState,
    on(
        CompaniesUIActions.setCompaniesFilter,
        (state, { filter }) => ({
            ...state,
            filter
        })
    ),
    on(
        CompaniesUIActions.setCurrentCompany,
        (state, { companyId: currentCompanyId }) => 
            state.currentCompanyId !== currentCompanyId
            ? { ...state, currentCompanyId, currentCompanyIdChanged: true }
            : { ...state, currentCompanyIdChanged: false }
    ),
    on(
        CompaniesUIActions.resetCurrentPeriod,
        (state) => ({
            ...state,
            currentPeriod: initialState.currentPeriod
        })
    ),
    on(
        CompaniesUIActions.setCurrentPeriod,
        (state, { period: currentPeriod  }) =>
            (state.currentPeriod !== currentPeriod)
                ? { ...state, currentPeriod, currentPeriodChanged: true }
                : { ...state, currentPeriodChanged: false }
    )
);
